<template>
	<div>
		<div>
			<h2>开发服务器列表</h2><br>
			<hr><br>
		</div>
	     <div style="padding-left: 80px;" v-html="htmlData"> </div>
	</div>
</template>

<script>
import api from '@/api/system/dev-standards.js';
export default {
	name: 'dev-front',
	data() {
		return {
               htmlData: ""
		};
	},

	methods: {

	},
	mounted() {
	api.getStandardsApi({id:59}, response => {
				this.htmlData = response.data.content;
			})
	}
};
</script>

<style lang="scss" scoped="scoped"></style>
